import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import "@mdi/font/css/materialdesignicons.css";

// Vuetify locales personalizados
import { customLocales } from "@/i18n/vuetifyLocales";

// Temas dos Orixás
import { generateVuetifyThemes } from "@/themes/vuetifyThemes";

export default createVuetify({
	components,
	directives,
	locale: {
		locale: localStorage.getItem("locale") || "pt-BR",
		fallback: "pt-BR",
		messages: customLocales,
		rtl: {
			"pt-BR": false,
			"en-US": false,
		},
	},
	theme: {
		defaultTheme: (() => {
			const savedTheme = localStorage.getItem("orixaTheme") || "ori";
			const savedDark = localStorage.getItem("isDark") === "true";
			return `${savedTheme}-${savedDark ? "dark" : "light"}`;
		})(),
		themes: generateVuetifyThemes(),
	},
});
